export const PAYROLL_CUSTOM_FIELD_TYPE = {
  FIXED: 'fixed',
  AUTO_FIXED: 'auto-fixed',
  HOURS_RELATED: 'hours-related',
  HOURLY_WAGE_PERCENTAGE: 'hourly-wage-percentage'
};

// Summarized payroll export buckets the two time-off columns by type.
export const SUMMARIZED_SICK_HOURS_COLUMN = 'totalSickDayHours';
export const SUMMARIZED_VACATION_HOURS_COLUMN = 'totalVacationHours';

// Contract leave management has no fixed enum — leave types are per-account rows whose `leaveType`
// is the configured name. German accounts name them "Krank" / "Urlaub"; keys are lowercased+trimmed.
export const LEAVE_TYPE_NAME_TO_SUMMARIZED_COLUMN = {
  krank: SUMMARIZED_SICK_HOURS_COLUMN,
  urlaub: SUMMARIZED_VACATION_HOURS_COLUMN
};
